'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MaterialPaper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { excludeComponentProps } from '../utils/excludeComponentProps';
const StyledPaper = styled(MaterialPaper, {
    ...excludeComponentProps('borderRadius')
})(({ theme, square, borderRadius, variant }) => ({
    boxShadow: theme.tokens.FuelShadowBase,
    ...variant === 'elevated' && {
        boxShadow: theme.tokens.FuelShadowBase
    },
    ...variant === 'outlined' && {
        boxShadow: undefined,
        border: `solid 1px ${theme.tokens.FuelColorBorderLight}`
    },
    ...(borderRadius === 'sm' || borderRadius === 'small') && {
        borderRadius: theme.tokens.FuelBorderRadiusSm
    },
    ...(borderRadius === 'md' || borderRadius === 'medium') && {
        borderRadius: theme.tokens.FuelBorderRadiusMd
    },
    ...(borderRadius === 'lg' || borderRadius === 'large') && {
        borderRadius: theme.tokens.FuelBorderRadiusLg
    },
    ...borderRadius === 'xl' && {
        borderRadius: theme.tokens.FuelBorderRadiusXl
    },
    ...borderRadius === '2xl' && {
        borderRadius: theme.tokens.FuelBorderRadius2xl
    },
    ...borderRadius === 'full' && {
        borderRadius: theme.tokens.FuelBorderRadiusFull
    },
    ...(borderRadius === 'none' || square) && {
        borderRadius: theme.tokens.FuelBorderRadiusNone
    }
}));
export const Paper = React.forwardRef(({ borderRadius = 'lg', ...props }, ref) => (_jsx(StyledPaper, { borderRadius: borderRadius, ref: ref, ...props })));
Paper.displayName = 'Paper';
